import { ZBEdgeState } from '@/types/storeTypes'
import Vuex from 'vuex'

export const store = new Vuex.Store<ZBEdgeState>({
  state: {
    apps: [],
    browserLocale: '',
    fullName: '',
    initiated: false,
    authLoading: false,
    appDependenciesLoaded: false,
    redirectBeforeRouteEnter: false,
    loadingCount: 0,
    loggedIn: false,
    hasUnredeemedInvites: false,
    sessionId: undefined,
    lastExternalAppSeconds: undefined,
    apiServerAvailable: false,
    matchingUserFound: false,
    skipPortalLandingPage: false,
    federatedTenantRequiredForZBEmployees: false,
    alwaysShowMigrationMessage: false,
    moreApps: [],
    userAvatarUrl: '',
    userId: null,
    aboutUrl: '',
    supportUrl: '',
    findInvitesPath: '',
    passwordMinLength: 0,
    error: null,
    appRedirect: '',
    cookieExpireMinutes: 0,
    // Populated at startup from /api/config; empty names resolve to "no cookie" until then (no caller reads pre-load).
    cookieContract: {
      xsrfRequestToken: '',
      countryCode: '',
      countryCodeWrite: { maxAgeSeconds: 0, sameSite: '', secure: true, path: '/' },
      noPreloginRedirect: '',
      grantPermissionRedirect: '',
      appRedirectPath: ''
    },
    // SMART launch context, config-driven (keys pre-translated to external{TokenName} by /api/auth/status);
    // hydrated on every (re)load via AuthStatusLoader (server session).
    launchContext: undefined,
    // Per-launch browser-tab identifier minted at /fhir/r4/launch; hydrated from /api/auth/status.
    browserTabId: undefined,
    // SMART launch type ("Embedded" iframe vs "External" top-level) from the SMART session; undefined for non-SMART sessions.
    launchType: undefined,
    // Embedded-compatible app keys from /api/auth/status (applied only to Embedded launches); undefined for non-SMART sessions.
    smartCompatibleApplicationKeys: undefined
  }
})